import {LOGOUT} from "../../actions/AuthActions";
import {RESET_STATE} from "../../reducers";

export default ({dispatch}) => next => action => {
    next(action);

    const {type, payload} = action;

    switch (type) {
        case LOGOUT: {
            dispatch({type: RESET_STATE});
            break;
        }
    }
};
